module.exports = __webpack_public_path__ + "media/images/button-right-db076589d6d06496c17169115ae67a22.png";